export const FLEET_PROFILE = 'fleet';
export const WAREHOUSE_PROFILE = 'warehouses';